import { createContext } from "react";

const LeaveApplicationContext = createContext();

export default LeaveApplicationContext;